// src/modules/supplier/supplierService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
    return localStorage.getItem('token');
  };
  const token = getToken();

export const getSuppliers = async () => {
  const response = await axios.get(`${API_URL}/suppliers`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};
export const getSupplier = async (id) => {
  const response = await axios.get(`${API_URL}/suppliers/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

// Create a new supplier
export const createSupplier = async (supplierData) => {
  console.log("Sup Data: ", supplierData);
  const response = await axios.post(`${API_URL}/suppliers`, supplierData, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  console.log("Sup Response: ", response.data);
  return response.data;
};

// Update an existing supplier
export const updateSupplier = async (id, supplierData) => {
  const response = await axios.put(`${API_URL}/suppliers/${id}`, supplierData, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const deleteSupplier = async (id) => {
  const response = await axios.delete(`${API_URL}/suppliers/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const getCategories = async () => {
  const response = await axios.get(`${API_URL}/supplier-categories`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const getCategory = async (id) => {
  const response = await axios.get(`${API_URL}/supplier-categories/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const createCategory = async (category) => {
  const response = await axios.post(`${API_URL}/supplier-categories`, category, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const updateCategory = async (id, category) => {
  const response = await axios.put(`${API_URL}/supplier-categories/${id}`, category, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/supplier-categories/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;
};

export const getProducts = async () => {
  console.log("Retornando Produtos");
  const response = await axios.get(`${API_URL}/products`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
  return response.data;  // Assuming the API returns an array of products
};
